import { requestJSON } from "./http";

const list = (accessToken) =>
  requestJSON({ path: "/reference-data", accessToken });

export default {
  list,
};
